import styled from 'styled-components';

export const Spacer = styled.div<{ size?: string }>`
  margin: ${({ size }): string => {
    return size || '50px';
  }};
`;
